import React from "react";
import { useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import {
  emptyError,
  invalidTextFieldError,
  isBlank,
  useUpdateIncluded,
  validateTextField,
} from "../../../utils/commonUtils";
import TextField from "./TextField";
import { STREET_ADDRESS } from "../../../utils/enums";

const CustomerAddress = observer(({ FeedbackStore }) => {
  const key = "address";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const address = feedback.address;
  const msgs = useMessageGetter("feedback.form.address");

  // Update included property when customer info value changes
  useUpdateIncluded(key, feedback.customerInfo.value, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(address.value)) {
      updateError(key, emptyError(msgs));
    } else {
      updateError(
        key,
        validateTextField(address.value) ? false : invalidTextFieldError(msgs)
      );
    }
  };

  return (
    <TextField
      fieldName={key}
      autocomplete={STREET_ADDRESS}
      value={address.value}
      error={address.error}
      handleOnChange={handleOnChange}
      handleOnBlur={handleOnBlur}
      maxLength={50}
    />
  );
});

export default inject("FeedbackStore")(CustomerAddress);
